import { render, staticRenderFns } from "./ParametrizacaoContratoPasso5.vue?vue&type=template&id=fdec8a3c&lang=html"
import script from "./ParametrizacaoContratoPasso5.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoContratoPasso5.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoContratoPasso5.vue?vue&type=style&index=0&id=fdec8a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports